export enum SortStudents {
  STUDENTS,
  ROLLOVER,
  PREREQ,
  CORE,
  TEACHER_ASSIGNED,
  ASSIGNED_TIME,
}

export enum SortDetails {
  DATE,
  OBJECTIVE,
  SKILL,
  CATEGORY,
  MASTERY,
  STATUS,
  ASSIGNED_TIME,
}

export enum SortDirection {
  NONE,
  ASC,
  DES,
}
